import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-search-info',
  templateUrl: './search-info.component.html',
  styleUrls: ['./search-info.component.scss']
})
export class SearchInfoComponent implements OnInit {
  @Input('searchText') searchText: string;
  @Input('fileCount') fileCount: number;

  constructor() { console.log("created") }

  ngOnInit() {
  }

}
